import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { ONBOARDING_API } from "./apiRoutes";
import axiosAuth from "@/services/axiosAuth";

interface UseDownloadUserTemplateProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const downloadUserTemplate = async (communityId: string) =>
  await axiosAuth.get(`${ONBOARDING_API(communityId)}/occupancy/template`, {
    responseType: "blob",
  });

const useDownloadUserTemplate = ({
  communityId,
  queryParams
}: UseDownloadUserTemplateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["download-user-template", communityId],
    queryFn: () => downloadUserTemplate(communityId),
    select: (data: any) => data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useDownloadUserTemplate;
